/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_CopiedInputs */

const vi_payment_qr_copied = /** @type {(inputs: Payment_Qr_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã sao chép!`)
};

/**

* @param {Payment_Qr_CopiedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_copied = /** @type {((inputs?: Payment_Qr_CopiedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_CopiedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_copied(inputs)
});